import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { locationsScheme } from "../../../lib/validations/locationsValidation";
import { getAllCPs, updateConnector } from "../../../apis/chargingPointsApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function Updatecps() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [addLocationsInitial, setAddLocationsInitial] = useState({
    name: "",
    price: "",
    plugType: "",
    cpId: "",
    gmePrice: "",
    status: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getconInfo(id);
    }
  }, [id]);

  const getconInfo = async (id) => {
    setEditLoader(true);
    try {
      const res = await getAllCPs(id);
      if (res.result) {
        setAddLocationsInitial({
          name: res.result.label,
          price: res.result.price,
          plugType: res.result.plugType,
          cpId: res.result.cpId,
          gmePrice: res.result.gme_price,
          status: res.result.status,
        });
        setEditLoader(false);
      }
    } catch (error) {
      console.error("Error fetching Locations:", error);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: addLocationsInitial,
    enableReinitialize: true,
    // validationSchema: locationsScheme,
    onSubmit: async (values) => {
      console.log(values);
      try {
        setLoading(true);
        let res;
        if (id) {
          res = await updateConnector(id, values);
          console.log(res);
        }
        // else {
        //   res = await createAndUpdateLocationsServer(null, values);
        // }
        setLoading(false);
        formik.resetForm();
        navigate("/ChargingPoints");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/ChargingPoints");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  {/* Name */}
                  <TextInputFormik label="Name" field="name" formik={formik} />

                  {/* Price */}
                  <TextInputFormik
                    label="Price"
                    field="price"
                    formik={formik}
                  />

                  {/* Plug Type */}
                  <TextInputFormik
                    label="Plug Type"
                    field="plugType"
                    formik={formik}
                  />

                  {/* CP Id */}
                  <TextInputFormik label="CP ID" field="cpId" formik={formik} />

                  {/* GME Price */}
                  <TextInputFormik
                    label="GME Price"
                    field="gmePrice"
                    formik={formik}
                  />

                  {/* Status */}
                  <TextInputFormik
                    label="Status"
                    field="status"
                    formik={formik}
                  />

                  {/* Submit button or loading spinner */}
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
